// The Activities page's URL vocabulary for an open item — what it keeps about
// itself in the URL, and what OTHER pages (the AI assistant's answers) use to
// deep-link into it. Both params STAY: the page keeps them in step with the
// open drawer, so the URL is a shareable link that survives a refresh. An
// activity's drawer tab rides alongside as the Scheduler's `tab` param.

/** `?openActivity=<taskId>` opens that activity's task panel. */
export const OPEN_ACTIVITY_PARAM = 'openActivity';

/** `?openIssue=<issueId>` opens that issue's drawer. */
export const OPEN_ISSUE_PARAM = 'openIssue';

/** The retired `?item=act:<id>` / `?item=iss:<id>`. Links already handed out
 *  (stored assistant answers) still carry it, so the page rewrites it to the
 *  params above on arrival (`useLinkedFilters`). */
export const LEGACY_ITEM_PARAM = 'item';
